<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>编辑权限</v-card-title>
      <v-card-text>
        <div class="mb-4">
          <div class="subtitle-1 mb-2 blue--text">用户信息</div>
          <div>账号：{{ userData.account }}</div>
          <div>姓名：{{ userData.name }}</div>
        </div>

        <div class="mb-4">
          <div class="subtitle-1 mb-2 blue--text">当前权限</div>
          <div v-if="loading" class="d-flex justify-center my-4">
            <v-progress-circular indeterminate></v-progress-circular>
          </div>
          <div v-else>
            <v-chip
              v-for="permission in permissions"
              :key="permission.categoryId"
              class="ma-1"
              color="primary"
              close
              @click:close="removePermission(permission)"
            >
              {{ permission.name }}
            </v-chip>
            <div v-if="permissions.length === 0" class="grey--text">
              暂无权限
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div class="subtitle-1 mb-2 blue--text">新增权限</div>
          <div class="d-flex align-center">
            <v-select
              v-model="selectedCategory"
              :items="availableCategories"
              item-text="name"
              item-value="categoryId"
              label="选择权限"
              class="mr-2"
              hide-details
            ></v-select>
            <v-btn 
              color="primary" 
              @click="addPermission"
              :disabled="!selectedCategory"
            >
              新增
            </v-btn>
          </div>

          <div class="mt-4">
            <v-chip
              v-for="category in addedCategories"
              :key="category.categoryId"
              class="ma-1"
              color="success"
              close
              @click:close="cancelAdd(category)"
            >
              {{ category.name }}
            </v-chip>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">关闭</v-btn>
        <v-btn 
          color="primary" 
          text 
          @click="saveChanges"
          :loading="saving"
          :disabled="!hasChanges"
        >
          储存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userApi } from '@/api/user'
import { courseApi } from '@/api/course'

export default {
  name: 'EditPermissionDialog',
  
  data() {
    return {
      dialog: false,
      loading: false,
      saving: false,
      userData: {},
      courseCategories: [],
      permissions: [],
      selectedCategory: null,
      addedCategories: [],
      removedCategoryIds: [],
    }
  },

  computed: {
    availableCategories() {
      // 过滤掉已有权限和已添加的权限
      return this.courseCategories.filter(category => {
        const isExisting = this.permissions.some(p => p.categoryId === category.categoryId);
        const isAdded = this.addedCategories.some(p => p.categoryId === category.categoryId);
        return !isExisting && !isAdded;
      });
    },

    hasChanges() {
      return this.addedCategories.length > 0 || this.removedCategoryIds.length > 0;
    }
  },

  methods: {
    async open(userData) {
      this.dialog = true;
      this.userData = userData;
      await this.fetchCourseCategory();
      await this.fetchPermissions();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.resetData();
      });
    },

    resetData() {
      this.permissions = [];
      this.userData = {};
      this.selectedCategory = null;
      this.addedCategories = [];
      this.removedCategoryIds = [];
    },

    addPermission() {
      if (!this.selectedCategory) return;
      
      const category = this.courseCategories.find(c => c.categoryId === this.selectedCategory);
      if (category) {
        this.addedCategories.push(category);
        this.selectedCategory = null;
      }
    },

    cancelAdd(category) {
      this.addedCategories = this.addedCategories.filter(c => c.categoryId !== category.categoryId);
    },

    removePermission(permission) {
      this.permissions = this.permissions.filter(p => p.categoryId !== permission.categoryId);
      this.removedCategoryIds.push(permission.categoryId);
    },

    async saveChanges() {
      this.saving = true;
      try {
        await userApi.updateJobSeekerPermissions(
          this.userData.userId,
          this.addedCategories.map(c => c.categoryId),
          this.removedCategoryIds
        );
        
        await this.fetchPermissions(); // 重新加载权限
        this.addedCategories = [];
        this.removedCategoryIds = [];
        this.$toast.success('权限更新成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('更新失败：' + errorMessage);
      } finally {
        this.saving = false;
      }
    },

    async fetchPermissions() {
      this.loading = true;
      try {
        const response = await userApi.getJobSeekerPermissions(this.userData.userId);
        this.permissions = response.data;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取权限失败：' + errorMessage);
      } finally {
        this.loading = false;
      }
    },

    async fetchCourseCategory() {
        try {
            const response = await courseApi.getCourseCategories();
            console.log('response = ', response);
            this.courseCategories = response.data;
            console.log('this.courseCategories = ', this.courseCategories);
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || '未知错误';
            this.$toast.error('获取权限失败：' + errorMessage);
        }
    },
  }
}
</script> 